import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../../../utils/Constant";
import styles from "../LeftNavigation.module.scss";
import { useTranslation } from "react-i18next";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

const HomeNav = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const onClick = useCallback(async () => {
    history.push(ROUTES.HOME);
  }, [history]);

  return (
    <div className={styles.actionContainer}>
      <div className={styles.actionItem} onClick={onClick}>
        <div className={styles.actionIcon}>
          <HomeOutlinedIcon />
        </div>
        <span className={styles.display}>{t("navigation.home")}</span>
      </div>
    </div>
  );
};

export default HomeNav;
